import { getGeneralLedgerData, getledgerbalance } from "./generalledger.js";

export function getEquityAccounts(context) {  //20250213
    const {
        equityaccounts,
        currencies,
        exchangerates,
    } = context;

    const generalledgerdata = getGeneralLedgerData(context);
    let filteredledgerdata = generalledgerdata
        .filter(data => data.accounttype == 'equityaccounts')

    const data = [];

    equityaccounts.forEach((account) => {
        let accountledgers = filteredledgerdata
            .filter(data => data.accountid == account.id)

        let currencysymbol = currencies.find(curr => curr.id == account.currencyid)?.symbol

        data.push({
            id: account.id,
            name: account.name,
            currencyid: account.currencyid,
            currencysymbol: currencysymbol,
            balance: getledgerbalance(accountledgers, exchangerates, account.currencyid, 'equityaccounts'),
        });
    });

    data.sort((a, b) => {
        const nameComparison = a.name.localeCompare(b.name, 'en', { numeric: true });
        if (nameComparison === 0) {
            return parseFloat(a.balance) - parseFloat(b.balance);
        }
        return nameComparison;
    });

    return data;
}